/**
 * @file: 收集复制对象
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';

/**
 * 查找顺序
 *
 * 1. 货架
 * 2. 层板
 * 3. 商品
 */
function findCopyTarget(selected: Array<CubeId>): Array<CubeId> {
    let result: Set<CubeId> = new Set();

    // 找货架
    selected.forEach((cubeId: CubeId): void => {
        if (CubeTree.isShelf(cubeId)
            || CubeTree.isFreezer(cubeId)) {
            result.add(cubeId);
            return;
        }
    });

    // 找层板
    selected.forEach((cubeId: CubeId): void => {
        if (CubeTree.isPartition(cubeId)) {
            let itsShelf: CubeId|null = CubeTree.findCubeShelf(cubeId);

            if (!result.has(itsShelf)) {
                result.add(cubeId);
                return;
            }
        }
    });

    // 找商品、文本框、隔板
    selected.forEach((cubeId: CubeId): void => {
        if (CubeTree.isGoods(cubeId)
            || CubeTree.isBafflePlate(cubeId)
            || CubeTree.isTextarea(cubeId)) {
            let itsShelf: CubeId|null = CubeTree.findCubeShelf(cubeId);
            let itsLayer: CubeId|null = CubeTree.findCubeLayer(cubeId);

            if (!result.has(itsLayer)
                && !result.has(itsShelf)) {
                result.add(cubeId);
            }
        }
    });

    return Array.from(result);
}

export {
    findCopyTarget
};
